import Component from '@glimmer/component';

interface ComponentArgs {
  header: string;
}

export default class MergeContactsSection extends Component<ComponentArgs> {
  <template>
    <div class='bg-gray-100 px-2 py-1 border-left border-right tw-font-semibold'>
      {{@header}}
    </div>
    <div class='border px-2 py-1'>
      {{yield}}
    </div>
  </template>
}
